import React from "react";
import '../App.css';

const VideoCarousel = () => {
  return (
    <div className="video-carousel-container">
      <div className="video-wrapper">
        <video
          /* ✅ Pehle wala UI + Vercel Blob URL */
          src="https://urjpoe48gnvlh7ux.public.blob.vercel-storage.com/lv_0_20260212193427.mp4" 
          controls
          loop
          muted         
          playsInline    
          autoPlay
          className="carousel-video"
        />
      </div>
    </div>
  );
};

export default VideoCarousel;